import React, { useState, useEffect } from 'react';
import { MdCopyAll } from 'react-icons/md'; 
import { Toast } from './ToastContext';
const CopyUID = ({ id, title = "Copy UID", className = "taskicon" }) => {
  const { Toastshow } = Toast();

  const handleCopy = async () => {
    if (!id) {
      Toastshow("Nothing to copy");
      return;
    }
    try {
      await navigator.clipboard.writeText(id);
      Toastshow("Copied");
    } catch (err) { 
      Toastshow("Failed to copy");
    }
  };

  return (
    <MdCopyAll
      onClick={handleCopy}
      title={title}
      className='icon'
      style={{ cursor: 'pointer' }}
    />
  );
};

export default CopyUID;
